import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import withStyles from "@material-ui/core/styles/withStyles";
import Tab from "@material-ui/core/Tab";
import Tooltip from "@material-ui/core/Tooltip";
import {
  setSaveProgress,
  removeSaveProgress,
} from "Actions/SaveProgressAction";

import Tabs from "@material-ui/core/Tabs";
import { instance } from "Actions/AxiosInstance";
import backArrow from "Assets/newicons/arrow/line-arrow/left/outline/line-arrow-left-outline-16px.svg";
import nextArrow from "Assets/newicons/arrow/line-arrow/right/outline/line-arrow-right-outline-16px.svg";
import checkGlyph from "Assets/newicons/notify/check-round/glyph/check-round-outline-blue-16px.svg";
import checkGlyphWhite from "Assets/newicons/notify/check-round/glyph/check-round-outline-white-16px.svg";
import DynamicForm from "Component/DynamicForm";
import { checkboxinputconverter } from "Component/DynamicForm/Fields/CheckBox";
import { selectinputconverter } from "Component/DynamicForm/Fields/Select";
import { textinputconverter } from "Component/DynamicForm/Fields/Text";
import SectionHeaderExtraSmall from "Component/Headers/sectionHeaderExtraSmall";
import { ErrorMessages } from "Constants";
import $ from "jquery";
import { withSnackbar } from "notistack";
import React, { Component } from "react";
import ReactQuill from "react-quill";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { convertTOBase64 } from "Utils";
import List from "@material-ui/core/List";
import Popover from "@material-ui/core/Popover";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import loader from "Assets/Gif/loader.gif";
import VARIBALES from "../PipelineMailTemplates/variables";

const formats = [
  "header",
  "bold",
  "italic",
  "underline",
  "strike",
  "blockquote",
  "list",
  "bullet",
  "indent",
  "link",
];

class MailSetup extends Component {
  constructor(props) {
    super(props);
    this.state = {
      // postData: props.postData,
      postData: props.postData,

      mailTemplates: [],
      // selectedpipelinestage: null,
      ismailtemploading: false,
      pipelinestage:
        props.postData.pipelinestage.length != 0
          ? props.postData.pipelinestage
          : [
              {
                pipelinestageid: null,
                stagename: "New",
                description: null,
                stagecategoryid: 1,
                stageorder: 1,
                pipelineconfigmail: null,
              },
              {
                pipelinestageid: null,
                stagename: "Screening",
                description: null,
                stagecategoryid: 2,
                stageorder: 2,
                pipelineconfigmail: null,
              },
              {
                pipelinestageid: null,
                stagename: "Interviewing",
                description: null,
                stagecategoryid: 3,
                stageorder: 3,
                pipelineconfigmail: null,
              },
              {
                pipelinestageid: null,
                stagename: "Offered",
                description: null,
                stagecategoryid: 4,
                stageorder: 4,
                pipelineconfigmail: null,
              },
              {
                pipelinestageid: null,
                stagename: "Disqualify",
                description: null,
                stagecategoryid: 5,
                stageorder: 5,
                pipelineconfigmail: null,
              },
              {
                pipelinestageid: 17,
                stagename: "Hired",
                description: null,
                stagecategoryid: 6,
                stageorder: 6,
                pipelineconfigmail: null,
              },
            ],
      tabId: 0,
      modules: props.modules2,
      selectedpipelinestage:
        props.postData.pipelinestage.length != 0
          ? props.postData.pipelinestage[0]
          : {
              pipelinestageid: null,
              stagename: "New",
              description: null,
              stagecategoryid: 1,
              stageorder: 1,
              pipelineconfigmail: null,
            },
      formats,
      templatebody: "",
      templatename: "",
      mailTemplateId: "",
      mailTemplatesDetails: {},
      subject: "",
      isSaveNew: false,
    };

    this.onSave = this.onSave.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleVerticalChange = this.handleVerticalChange.bind(this);
    this.onSaveDraft = this.onSaveDraft.bind(this);
  }

  componentDidMount() {
    this.props.onRef({
      onNext: this.onSave,
      onSaveDraft: this.state.postData.pipelineid ? "" : this.onSaveDraft,
      onCancel: this.props.onCancel,
    });
    this.getMailTemplate();

    const x = () => {
      $("span").removeClass("ql-selected");
    };
    x();
    const placeholderPickerItems = Array.prototype.slice.call(
      document.querySelectorAll(".ql-placeholder .ql-picker-item"),
    );
    placeholderPickerItems.forEach(
      (item) => (item.textContent = item.dataset.value),
    );
    document.querySelector(".ql-placeholder .ql-picker-label").innerHTML =
      "{ }";
  }

  // handleVerticalChange(id, value) {
  //   this.setState({
  //     tabId: id,
  //     selectedpipelinestage: value,
  //     mailTemplateId: value.pipelineconfigmail && value.pipelineconfigmail.mailtemplateid
  //   });
  // }

  handleChange(key, value) {
    const { selectedpipelinestage, subject = "" } = this.state;
    if (key == "mailTemplateId") {
      if (value) {
        this.getMailTemplateDeatils(value);
      } else {
        this.getMailTemplateDeatils1(value);
      }
    } else if (
      key == "emailbody" &&
      selectedpipelinestage &&
      selectedpipelinestage.pipelineconfigmail
    ) {
      selectedpipelinestage.pipelineconfigmail[key] = value;
      this.setState({
        selectedpipelinestage,
      });
    } else if (
      key == "issavetemplate" &&
      selectedpipelinestage &&
      selectedpipelinestage.pipelineconfigmail &&
      (selectedpipelinestage.pipelineconfigmail.tempemailbody &&
        selectedpipelinestage.pipelineconfigmail.tempemailbody) !=
        (selectedpipelinestage.pipelineconfigmail.emailbody &&
          selectedpipelinestage.pipelineconfigmail.emailbody)
    ) {
      selectedpipelinestage.pipelineconfigmail.savetemplate = null;
      selectedpipelinestage.pipelineconfigmail.issavetemplate = value;
      if (value == true) {
        // selectedpipelinestage.pipelineconfigmail.savetemplate = {
        //   commodityid: 6,
        //   templatename: selectedpipelinestage.pipelineconfigmail.templatename,
        //   mailtemplateid: null,
        //   subject: selectedpipelinestage.pipelineconfigmail.subject,
        //   subjectvariableids:
        //     selectedpipelinestage.pipelineconfigmail.subjectvariableids,
        //   emailbodypath: selectedpipelinestage.pipelineconfigmail.emailbodypath,
        //   emailbody: selectedpipelinestage.pipelineconfigmail.emailbody,
        //   emailvariableids:
        //     selectedpipelinestage.pipelineconfigmail.emailvariableids,
        // };
        selectedpipelinestage.pipelineconfigmail.savetemplate = {
          commodityid: 6,
          templatename: null,
          mailtemplateid: null,
          subject: null,
          subjectvariableids:
            selectedpipelinestage.pipelineconfigmail.subjectvariableids,
          emailbodypath: selectedpipelinestage.pipelineconfigmail.emailbodypath,
          emailbody: selectedpipelinestage.pipelineconfigmail.emailbody,
          emailvariableids:
            selectedpipelinestage.pipelineconfigmail.emailvariableids,
        };
      }
      this.setState({
        selectedpipelinestage,
        [key]: value,
      });
    } else if (
      key == "templatename" &&
      selectedpipelinestage &&
      selectedpipelinestage.pipelineconfigmail &&
      selectedpipelinestage.pipelineconfigmail.savetemplate
    ) {
      selectedpipelinestage.pipelineconfigmail.savetemplate.templatename =
        value;
      this.setState({
        selectedpipelinestage,
        [key]: value,
      });
    } else if (
      key == "subject" &&
      selectedpipelinestage &&
      selectedpipelinestage.pipelineconfigmail &&
      selectedpipelinestage.pipelineconfigmail.savetemplate
    ) {
      selectedpipelinestage.pipelineconfigmail.savetemplate.subject = value;
      this.setState({
        selectedpipelinestage,
        [key]: value,
      });
    } else if (key == "selectsubject") {
      selectedpipelinestage.pipelineconfigmail.savetemplate.subject = `${
        selectedpipelinestage.pipelineconfigmail.savetemplate.subject
          ? selectedpipelinestage.pipelineconfigmail.savetemplate.subject
          : ""
      }{${value.variablevalue}}`;
      this.setState({
        selectedpipelinestage,
        sortmenu: false,
      });
    } else {
      this.setState({
        [key]: value,
      });
    }
  }

  async handleVerticalChange(value, isSave = false) {
    const { letterVariables } = this.props;
    const { selectedpipelinestage, tabId, postData, templatename } = this.state;
    if (
      selectedpipelinestage.pipelineconfigmail &&
      selectedpipelinestage.pipelineconfigmail.issavetemplate &&
      (!selectedpipelinestage.pipelineconfigmail.savetemplate.templatename ||
        !selectedpipelinestage.pipelineconfigmail.savetemplate.subject)
    ) {
      this.props.enqueueSnackbar("Please fill all required field", {
        variant: "error",
      });
      return false;
    } else if (selectedpipelinestage.pipelineconfigmail) {
      const subjectvariableids = [];
      const emailvariableids = [];
      letterVariables.forEach((x) => {
        if (
          selectedpipelinestage.pipelineconfigmail.subject &&
          selectedpipelinestage.pipelineconfigmail.subject.includes(
            `{${x.variablevalue}}`,
          )
        ) {
          subjectvariableids.push(x.displayvalue);
        }
        if (
          selectedpipelinestage.pipelineconfigmail.emailbody &&
          selectedpipelinestage.pipelineconfigmail.emailbody.includes(
            `{${x.variablevalue}}`,
          ) &&
          x.displayvalue != VARIBALES.letterlink
        ) {
          emailvariableids.push(x.displayvalue);
        }
      });
      selectedpipelinestage.pipelineconfigmail.subjectvariableids =
        subjectvariableids.join(",") || null;
      selectedpipelinestage.pipelineconfigmail.emailvariableids =
        emailvariableids.join(",") || null;
      if (selectedpipelinestage.pipelineconfigmail.issavetemplate == true) {
        // selectedpipelinestage.pipelineconfigmail.savetemplate.templatename = this.state.templatename;
        // selectedpipelinestage.pipelineconfigmail.savetemplate.subject = this.state.subject;
        delete selectedpipelinestage.pipelineconfigmail.savetemplate.emailbody;
      }
      // selectedpipelinestage.pipelineconfigmail.emailbody = selectedpipelinestage.pipelineconfigmail.emailbody.toString().replace(/(<([^>]+)>)/gi, "");
      // const data = {
      //   filename: "Email_template.html",
      //   appproductid: null,
      //   contenttype: "application/html",
      //   bufferdata: convertTOBase64(selectedpipelinestage.pipelineconfigmail.emailbody),
      //   employeeid: null,
      // };
      // const result = await instance.post("employee/uploadbufferfile", data);
      // selectedpipelinestage.pipelineconfigmail.emailbodypath = result.data.result[0].imagepath;
      postData.pipelinestage[tabId] = selectedpipelinestage;

      if (isSave == false) {
        this.setState({
          tabId: value,
          selectedpipelinestage: postData.pipelinestage[value],
          mailTemplateId: null,
          isSaveNew: false,
          templatename: null,
          subject: null,
        });
      }
    } else if (isSave == false && value != null) {
      this.setState({
        tabId: value,
        selectedpipelinestage: postData.pipelinestage[value],
        mailTemplateId: null,
        isSaveNew: false,
        templatename: null,
        subject: null,
      });
    }
    return true;
  }

  onPrevClick = () => {
    const { tabId, postData } = this.state;
    this.setState({
      tabId: tabId - 1,
      selectedpipelinestage: postData.pipelinestage[tabId - 1],
    });
  };

  onSave = async () => {
    const isUpdate = await this.handleVerticalChange(null, true);
    const { issaveinprogress } = this.props.SaveInProgressReducer;
    await this.updateBuffer();
    if (isUpdate == true) {
      let isvalid = true;
      const { pipelinestage, postData } = this.state;
      postData.isdraft = false;

      this.state.pipelinestage.map((item, index) => {
        item.stageorder = index + 1;
        if (!item.stagename) {
          isvalid = false;
        } else if (!item.stagecategoryid) {
          isvalid = false;
        }
        // else if (!item.pipelineconfigmail) {
        //   isvalid = false;
        // } else if (
        //   item.pipelineconfigmail &&
        //   !item.pipelineconfigmail.mailtemplateid
        // ) {
        //   isvalid = false;
        // } else if (
        //   item.pipelineconfigmail &&
        //   !item.pipelineconfigmail.subject
        // ) {
        //   isvalid = false;
        // }
        return item;
      });
      if (isvalid == false) {
        this.props.enqueueSnackbar("Please select mail template", {
          variant: "error",
        });
      } else {
        postData.noofstage = this.state.pipelinestage.length;
        postData.pipelinestage = this.state.pipelinestage;
        if (!issaveinprogress) {
          this.props.setSaveProgress(true);
          instance
            .post("recruit/configpipeline", postData)
            .then(() => {
              this.props.enqueueSnackbar(ErrorMessages.E0000, {
                variant: "success",
              });
              this.props.removeSaveProgress();
              this.props.history.push(`${this.props.match.path}`);
              this.props.getPipeline();
            })
            .catch((error) => {
              this.props.removeSaveProgress();
              this.props.enqueueSnackbar(
                error.response
                  ? error.response.data.error.message
                  : error.message,
                { variant: "error" },
              );
            });
        }
      }
    }
  };

  updateBuffer = async () => {
    const { postData } = this.state;
    await Promise.all(
      postData.pipelinestage.map(async (item) => {
        if (item.pipelineconfigmail && item.pipelineconfigmail.emailbody) {
          // item.pipelineconfigmail.emailbody = item.pipelineconfigmail.emailbody
          //   .toString()
          //   .replace(/(<([^>]+)>)/gi, "");
          const data = {
            filename: "Email_template.html",
            appproductid: null,
            contenttype: "application/html",
            bufferdata: convertTOBase64(item.pipelineconfigmail.emailbody),
            employeeid: null,
          };
          const result = await instance.post("employee/uploadbufferfile", data);
          item.pipelineconfigmail.emailbodypath =
            result.data.result[0].imagepath;
          if (item.pipelineconfigmail.issavetemplate == true) {
            item.pipelineconfigmail.savetemplate.emailbodypath =
              result.data.result[0].imagepath;
          }
        }
        // await Promise.all(this.setState({
        //   postData
        // }))
        return item;
      }),
    );
  };

  async onSaveDraft() {
    await this.handleVerticalChange(null, true);
    await this.updateBuffer();
    let isvalid = true;
    const { pipelinestage, postData } = this.state;
    postData.isdraft = true;
    pipelinestage.map((item, index) => {
      if (!item.stagename) {
        isvalid = false;
      } else if (!item.stagecategoryid) {
        isvalid = false;
      }
    });
    if (isvalid == false) {
      this.props.enqueueSnackbar("Please fill all required field", {
        variant: "error",
      });
    } else {
      postData.noofstage = this.state.pipelinestage.length;
      postData.pipelinestage = this.state.pipelinestage;
      instance
        .post("recruit/configpipeline", postData)
        .then(() => {
          this.props.enqueueSnackbar(ErrorMessages.E0000, {
            variant: "success",
          });
          this.props.history.push(`${this.props.match.path}`);
          this.props.getPipeline();
        })
        .catch((error) => {
          this.props.enqueueSnackbar(
            error.response ? error.response.data.error.message : error.message,
            { variant: "error" },
          );
        });
    }
  }

  getMailTemplate = () => {
    instance
      .post("subscription/getmailtemplatelist", {
        commodityid: 6,
        isactive: true,
      })
      .then((resp) => {
        const list = [
          {
            commodityid: 6,
            displayname: "None",
            displayvalue: "",
            templatecode: "",
          },
        ];
        const mailTemplates = [...resp.data.result, ...list];
        this.setState({ mailTemplates });
      })
      .catch((error) => {
        this.props.enqueueSnackbar(
          error.response ? error.response.data.error.message : error.message,
          { variant: "error" },
        );
      });
  };

  getMailTemplateDeatils = (mailtemplateid) => {
    this.setState({ ismailtemploading: true }, () => {
      instance
        .get(`subscription/getmailtemplate/${mailtemplateid}`)
        .then((resp) => {
          const selectedpipelinestage = this.state.selectedpipelinestage;
          selectedpipelinestage.pipelineconfigmail = {
            pipelinemailconfigid: null,
            mailtemplateid: resp.data.result[0].mailtemplateid,
            temptemplatename: resp.data.result[0].templatename,
            templatename: resp.data.result[0].templatename,
            issavetemplate: false,
            subject: resp.data.result[0].subject,
            subjectvariableids: resp.data.result[0].subjectvariableids,
            emailbody: resp.data.result[0].emailbody,
            emailbodypath: resp.data.result[0].emailbodypath,
            emailvariableids: resp.data.result[0].emailvariableids,
          };
          selectedpipelinestage.pipelineconfigmail.tempemailbody =
            selectedpipelinestage.pipelineconfigmail.emailbody;
          this.setState({
            selectedpipelinestage,
            mailTemplateId: mailtemplateid,
            ismailtemploading: false,
          });
        })
        .catch((error) => {
          this.setState({ calloading: false });
          this.props.enqueueSnackbar(
            error.response ? error.response.data.error.message : error.message,
            { variant: "error" },
          );
        });
    });
  };

  getMailTemplateDeatils1 = (mailtemplateid) => {
    const selectedpipelinestage = this.state.selectedpipelinestage;
    selectedpipelinestage.pipelineconfigmail = {
      pipelinemailconfigid: null,
      mailtemplateid: "",
      temptemplatename: "",
      templatename: "",
      issavetemplate: false,
      subject: "",
      subjectvariableids: "",
      emailbody: "",
      emailbodypath: "",
      emailvariableids: "",
    };
    selectedpipelinestage.pipelineconfigmail.tempemailbody =
      selectedpipelinestage.pipelineconfigmail.emailbody;
    this.setState({
      selectedpipelinestage,
      mailTemplateId: mailtemplateid,
      ismailtemploading: false,
    });
  };

  render() {
    const { postData, mailTemplatesDetails } = this.state;
    const { tabId, selectedpipelinestage } = this.state;
    const { letterVariables } = this.props;
    console.log(postData);
    return (
      <div>
        <Grid container>
          <Grid item xs={12} md={8} sm={12}>
            <p className="normal-dark-secondary margin-bottom-8">
              We send an automated mail to candidates upon movement of their
              application to a new stage in the pipeline. Configure and design
              the mail you’d like the candidates to receive. 📬
            </p>
          </Grid>
        </Grid>
        <Grid container spacing={3}>
          <Grid item md={3} sm={12}>
            <Paper
              className="rounded-rectangle-paper thin-scroll"
              style={{
                height: "58vh",
                boxSizing: "border-box",
                padding: "16px 0px",
                overflowY: "auto",
              }}
            >
              {postData &&
                postData.pipelinestage &&
                postData.pipelinestage.map((item, index) => (
                  <VerticalTabs
                    value={tabId}
                    // onChange={this.handleChange.bind(this, tabId)}
                    indicatorColor="primary"
                    textColor="primary"
                    className="right-border minheight40 cursor-pointer"
                  >
                    <MyTab
                      label={item.stagename}
                      onClick={() => this.handleVerticalChange(index)}
                      className={
                        this.state.tabId == index
                          ? "vertical-tab-item-selected"
                          : "vertical-tab-item"
                      }
                      icon={
                        this.state.tabId != null ? (
                          <img
                            src={checkGlyphWhite}
                            style={{
                              marginBottom: 0,
                              position: "absolute",
                              top: 12,
                              right: 12,
                            }}
                          />
                        ) : (
                          <img
                            src={checkGlyph}
                            style={{
                              marginBottom: 0,
                              position: "absolute",
                              top: 12,
                              right: 12,
                            }}
                          />
                        )
                      }
                      style={{ paddingLeft: 12 }}
                    />
                  </VerticalTabs>
                ))}
            </Paper>
          </Grid>
          <Grid item md={9} sm={12}>
            <Paper
              className="rounded-rectangle-paper padding16 thin-scroll"
              style={{
                boxSizing: "border-box",
                overflowY: "auto",
                height: "58vh",
              }}
            >
              <TabContainer>
                <div style={{ width: "50%" }}>
                  <DynamicForm
                    fields={selectinputconverter({
                      value:
                        (selectedpipelinestage.pipelineconfigmail &&
                          selectedpipelinestage.pipelineconfigmail
                            .mailtemplateid) ||
                        this.state.mailTemplateId,
                      placeholder: "Select mail template",
                      label: "Mail template",
                      options: this.state.mailTemplates,
                    })}
                    onChange={(selectedid) => {
                      this.handleChange("mailTemplateId", selectedid);
                    }}
                  />
                </div>
                {this.state.ismailtemploading ? (
                  <img className="loader" src={loader} height="40" />
                ) : (
                  <div>
                    <div className="margin-bottom-8">
                      <div className="rounded-rectangle-div margin-bottom-16">
                        <p className="small-dark-secondary">
                          <strong>Subject: </strong>
                          {selectedpipelinestage &&
                            selectedpipelinestage.pipelineconfigmail &&
                            selectedpipelinestage.pipelineconfigmail.subject}
                        </p>
                      </div>
                      <p className="small-dark-secondary margin-bottom-4">
                        Email body
                      </p>

                      <ReactQuill
                        theme="snow"
                        value={
                          (selectedpipelinestage &&
                            selectedpipelinestage.pipelineconfigmail &&
                            (selectedpipelinestage.pipelineconfigmail
                              .emailbody ||
                              selectedpipelinestage.pipelineconfigmail
                                .emailbodypath)) ||
                          ""
                        }
                        modules={this.state.modules}
                        formats={this.state.formats}
                        onChange={(value) => {
                          this.handleChange("emailbody", value);
                        }}
                      />
                    </div>
                    <div className="display-table">
                      <SectionHeaderExtraSmall header="📌 Press ‘ { } ‘ to see a selectable list of all possible placeholder variables." />
                    </div>
                    <DynamicForm
                      fields={checkboxinputconverter({
                        value:
                          (selectedpipelinestage &&
                            selectedpipelinestage.pipelineconfigmail &&
                            selectedpipelinestage.pipelineconfigmail
                              .issavetemplate) ||
                          false,
                        placeholder: "",
                        label: "Save as new template",
                      })}
                      onChange={(value) => {
                        this.handleChange("issavetemplate", value);
                      }}
                    />
                    {selectedpipelinestage &&
                      selectedpipelinestage.pipelineconfigmail &&
                      selectedpipelinestage.pipelineconfigmail
                        .issavetemplate && (
                        <div style={{ marginTop: -12 }}>
                          <div style={{ width: "50%" }}>
                            <DynamicForm
                              fields={textinputconverter({
                                value:
                                  (selectedpipelinestage.pipelineconfigmail &&
                                    selectedpipelinestage.pipelineconfigmail
                                      .savetemplate &&
                                    selectedpipelinestage.pipelineconfigmail
                                      .savetemplate.templatename) ||
                                  null,
                                placeholder: "Enter name",
                                label: "Template name",
                              })}
                              onChange={(value) => {
                                this.handleChange("templatename", value);
                              }}
                            />
                          </div>
                          <div
                            className="display-flex"
                            style={{ alignItems: "center" }}
                          >
                            <div style={{ width: "50%" }}>
                              <DynamicForm
                                fields={textinputconverter({
                                  value:
                                    (selectedpipelinestage.pipelineconfigmail &&
                                      selectedpipelinestage.pipelineconfigmail
                                        .savetemplate &&
                                      selectedpipelinestage.pipelineconfigmail
                                        .savetemplate.subject) ||
                                    null,
                                  label: "Subject",
                                  placeholder: "Enter subject",
                                })}
                                onChange={(e) =>
                                  this.handleChange("subject", e)
                                }
                              />
                            </div>

                            <Tooltip title="Select variables" placement="top">
                              <div
                                onClick={(e) =>
                                  this.setState({
                                    sortmenu: true,
                                    sort_anchorEl: e.currentTarget,
                                  })
                                }
                                className="cursor-pointer margin-left-16"
                                style={{ color: "#057cff" }}
                              >
                                {" { } "}
                              </div>
                            </Tooltip>
                          </div>
                        </div>
                      )}

                    <div className="clear-float"></div>
                  </div>
                )}
              </TabContainer>
            </Paper>
          </Grid>
        </Grid>
        <Popover
          open={this.state.sortmenu}
          anchorEl={this.state.sort_anchorEl}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "right",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "right",
          }}
          onClose={() =>
            this.setState({
              sortmenu: false,
              sort_anchorEl: null,
            })
          }
          className="margin-top-8"
        >
          <Paper style={{ width: 250 }}>
            <List className="cursor-pointer thin-scroll">
              {letterVariables &&
                letterVariables
                  .filter(
                    (option) =>
                      option.displayvalue != VARIBALES.signatory &&
                      option.displayvalue != VARIBALES.letterlink,
                  )
                  .map((option) => (
                    <ListItem
                      className="padding-right-0 padding-top-2 padding-bottom-2"
                      onClick={() => this.handleChange("selectsubject", option)}
                      style={{ height: 30 }}
                    >
                      <ListItemText style={{ paddingTop: 11 }}>
                        <p className="small-dark-secondary">
                          {option.displayname}
                        </p>
                      </ListItemText>
                    </ListItem>
                  ))}
            </List>
          </Paper>
        </Popover>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  DynamicForm: state.dynamicformReducer,
  Language: state.LanguageAction.Language,
  SaveInProgressReducer: state.SaveInProgressReducer,
});

const VerticalTabs = withStyles(() => ({
  flexContainer: {
    flexDirection: "column",
  },
  indicator: {
    display: "none",
  },
}))(Tabs);

const MyTab = withStyles(() => ({
  labelContainer: {
    padding: "6px 8px",
  },
  label: {
    color: "rgba(0, 0, 0, 0.87)",
  },
  icon: {
    display: "inline-black",
  },
}))(Tab);

function TabContainer(props) {
  return <div>{props.children}</div>;
}

const mapDispatchToProps = (dispatch) =>
  bindActionCreators({ setSaveProgress, removeSaveProgress }, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withSnackbar(MailSetup));
